import { createI18n } from 'vue-i18n';
import forEach from 'lodash/forEach';

const locale = document.documentElement?.lang?.split('-')[0] || 'en';

// -- LOCALIZATION
// Place Liferay-localized strings in here:
window.merkur.localizedStrings = window.merkur.localizedStrings || {};

// Load already initialized localized strings as messages into translated
const messages = {};
messages[locale] = {};

const loadLocalizedStrings = (object, prependKey = null) => {
    forEach(object, (value, key) => {
        if (typeof value === 'object' || Array.isArray(value)) {
            loadLocalizedStrings(value, key);
        } else {
            if (!prependKey) {
                messages[locale][key] = value;
            } else {
                messages[locale][prependKey] = messages[locale][prependKey] || {};
                messages[locale][prependKey][key] = value;
            }
        }
    });
};
loadLocalizedStrings(window.merkur.localizedStrings);

const i18n = createI18n({
    legacy: false,
    locale,
    messages,
    warnHtmlMessage: false,
});

export { i18n };
